var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    shapeRendering: "geometricPrecision",
    d: "M50 0a50 50 0 1 1 0 100A50 50 0 1 1 50 0m0 8a38 38 0 1 0 0 84 38 38 0 1 0 0-84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64.85 29.494 5.656 5.657-35.355 35.355-5.657-5.657z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29.494 35.15 5.657-5.656 35.355 35.355-5.657 5.657z"
  })));
};
export default SvgCloseIcon;